/**
 * @generated SignedSource<<9ec4c5e85a7c06f015852160a76debd3>>
 * @relayHash e47a8d762ffff04a617bbcb521f2ffa5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dfe29aeb7d5310c6db8859a9de6a2e7e88aba2fbf6339df8df5a30ef3f21bad3

import type { ConcreteRequest, Query } from 'relay-runtime';
export type getTenantRegionQuery$variables = {
  cloudIds?: ReadonlyArray<string> | null | undefined;
  product: string;
};
export type getTenantRegionQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly activationIdByProduct: {
      readonly targetRegion: string | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type getTenantRegionQuery = {
  response: getTenantRegionQuery$data;
  variables: getTenantRegionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "product"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudIds",
        "variableName": "cloudIds"
      }
    ],
    "concreteType": "TenantContext",
    "kind": "LinkedField",
    "name": "tenantContexts",
    "plural": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "product",
            "variableName": "product"
          }
        ],
        "concreteType": "TenantContextActivationId",
        "kind": "LinkedField",
        "name": "activationIdByProduct",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "targetRegion"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getTenantRegionQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getTenantRegionQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "dfe29aeb7d5310c6db8859a9de6a2e7e88aba2fbf6339df8df5a30ef3f21bad3",
    "metadata": {},
    "name": "getTenantRegionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6dc84af73dba89409a0c35ebb8003355";

export default node;
